/**
 * @file URLs for the pages list and editor that preserve chapter filter context.
 */

/**
 * All pages list, optionally filtered to one chapter (`?chapterId=`).
 */
export function pagesListHref(chapterId?: string | null): string {
  if (chapterId) {
    return `/dashboard/pages?chapterId=${encodeURIComponent(chapterId)}`;
  }
  return "/dashboard/pages";
}

/**
 * Page editor (and preview) with optional return context for the list back link.
 */
export function pageDetailHref(pageId: string, listChapterId?: string | null): string {
  const base = `/dashboard/pages/${pageId}`;
  if (listChapterId) {
    return `${base}?chapterId=${encodeURIComponent(listChapterId)}`;
  }
  return base;
}

export function pagePreviewHref(pageId: string, listChapterId?: string | null): string {
  const base = `/dashboard/pages/${pageId}/preview`;
  if (listChapterId) {
    return `${base}?chapterId=${encodeURIComponent(listChapterId)}`;
  }
  return base;
}
